// Button.jsx
import React, { forwardRef } from "react";
import styles from "./Button.module.scss";
import Loader from "./Loader";

const Button = forwardRef(({ onClick, icon, text, isActive, bgColor, textColor, loading, className }, ref) => {
  return (
    <button
      ref={ref}
      className={`${styles.button} ${isActive && styles.isActive} ${className}`}
      onClick={onClick}
      style={bgColor && { backgroundColor: bgColor }}
    >
      {loading && <Loader textColor={textColor} />}
      {!loading && icon && <span className={styles.icon}>{icon}</span>}
      {!loading &&
          <span
            className={styles.text}
            style={textColor && { color: textColor }}
          >{text}</span>
        }
    </button>
  );
});

export default Button;
